// Copyright 2016 OpaVote LLC.  All rights reserved.

import { default as Polyglot } from "node-polyglot"

var election = globalThis.election = (function($) {

  var my = {};
  var data, host, pg;

  var translations = {
    en: {
      add: 'Add',
      already_voted: 'You have already voted in this poll',
      ballot_error: 'Ballot Error',
      choice_list: 'Choice list',
      confirm: 'Confirm',
      confirm_empty: "Check the 'I want to submit an empty ballot' box to confirm your ballot is intentionally empty.",
      go_back: 'Go Back',
      may_select:
        'You may select up to %{smart_count} choice for %{title}||||' +
        'You may select up to %{smart_count} choices for %{title}',
      must_rank_all: 'You must rank all choices for %{title}',
      no_candidate_chosen: 'No choices made',
      please_confirm: 'Please confirm your ballot',
      remove: 'Remove',
      required_to_select:
'You are required to select exactly %{smart_count} choice for %{title}||||' +
'You are required to select exactly %{smart_count} choices for %{title}',
      sending_vote: 'Sending vote...',
      vote: 'Vote!',
      vote_entered: 'Your vote has been entered',
      your_ballot: 'Your ballot'
    },
    es: {
      add: 'Añadir',
      already_voted: 'Ya votó en esta encuesta',
      ballot_error: 'Error de boleta electoral',
      choice_list: 'Lista de opciones',
      confirm: 'Confirmar',
      confirm_empty: "Marque la casilla 'Deseo enviar una boleta vacía' para confirmar que su boleta está intencionalmente vacía.",
      go_back: 'Regresar',
      may_select:
'Puede elegir hasta %{smart_count} opción para %{title}||||' +
'Puede elegir hasta %{smart_count} opciones para %{title}',
      must_rank_all: 'Debe clasificar todas las opciones para %{title}',
      no_candidate_chosen: 'No hay opciones seleccionadas',
      please_confirm: 'Por favor confirme su voto',
      remove: 'Eliminar',
      required_to_select:
'Se le solicita que seleccione solo %{smart_count} opción ' +
'para %{title}||||' +
'Se le solicita que seleccione solo %{smart_count} opciones para %{title}',
      sending_vote: 'Enviando voto...',
      vote: '¡Votar!',
      vote_entered: 'Su voto ha sido introducido',
      your_ballot: 'Su voto'
    },
    fr: {
      add: 'Ajouter',
      already_voted: 'Vous avez déjà participé à ce vote',
      ballot_error: 'Erreur de vote',
      choice_list: 'Liste de choix',
      confirm: 'Confirmer',
      confirm_empty: "Cochez la case 'Je veux soumettre un bulletin de vote vide' pour confirmer que votre bulletin de vote est intentionnellement vide.",
      go_back: 'Retour',
      may_select:
'Vous pouvez sélectionner jusqu\'à %{smart_count} choix pour %{title}||||' +
'Vous pouvez sélectionner jusqu\'à %{smart_count} choix pour %{title}',
      must_rank_all: 'Vous devez classer tous les choix pour %{title}',
      no_candidate_chosen: 'Aucun choix sélectionné',
      please_confirm: 'Veuillez confirmer votre bulletin de vote',
      remove: 'Retirer',
      required_to_select:
'Vous devez choisir exactement %{smart_count} choix pour %{title}||||' +
'Vous devez choisir exactement %{smart_count} choix pour %{title}',
      sending_vote: 'Envoi du bulletin de vote...',
      vote: 'Vote!',
      vote_entered: 'Votre vote a bien été enregistré',
      your_ballot: 'Votre bulletin'
    },
    pt: {
      add: 'Adicionar',
      already_voted: 'Você já votou nesta enquete',
      ballot_error: 'Erro na votação',
      choice_list: 'Lista de escolhas',
      confirm: 'Confirmar',
      confirm_empty: "Marque a caixa 'Desejo enviar um boletim de voto em branco' para confirmar que seu boletim de voto está intencionalmente em branco.",
      go_back: 'Voltar',
      may_select:
'Você pode selecionar até %{smart_count} escolha para %{title}||||' +
'Você pode selecionar até %{smart_count} escolhas para o %{title}',
      must_rank_all: 'Você deve classificar todas as escolhas para %{title}',
      no_candidate_chosen: 'Nenhuma escolha feita',
      please_confirm: 'Por favor, confirme sua votação',
      remove: 'Remover',
      required_to_select:
'Você precisa selecionar exatamente %{smart_count} escolha ' +
'para %{title}||||' +
'Você precisa selecionar exatamente %{smart_count} opções ' +
'para %{title}',
      sending_vote: 'Enviando voto...',
      vote: 'Votar!',
      vote_entered: 'Seu voto foi registrado',
      your_ballot: 'Sua votação'
    },
    sk: {
      add: 'Pridať',
      already_voted: 'Už ste hlasovali',
      ballot_error: 'Chyba hlasovacieho lístka',
      choice_list: 'Zoznam možností',
      confirm: 'Potvrdiť',
      confirm_empty: "Zaškrtnite políčko 'Chcem odoslať prázdny hlasovací lístok' pre potvrdenie, že chcete odoslať prázdny hlasovací lístok.",
      go_back: 'Späť',
      may_select:
        'Môžete vybrať najviac %{smart_count} možnosť pre %{title}||||' +
        'Môžete vybrať najviac %{smart_count} možnosti pre %{title}||||' +
        'Môžete vybrať najviac %{smart_count} možností pre %{title}',
      must_rank_all: 'Musíte zoradiť všetky možnosti pre %{title}',
      no_candidate_chosen: 'Neboli vybrané žiadne možnosti',
      please_confirm: 'Prosím, potvrďte Váš hlasovací lístok',
      remove: 'Odstrániť',
      required_to_select:
'Musíte vybrať práve %{smart_count} možnosť pre %{title}||||' +
'Musíte vybrať práve %{smart_count} možnosti pre %{title}||||' +
'Musíte vybrať práve %{smart_count} možností pre %{title}',
      sending_vote: 'Posielam hlasovanie...',
      vote: 'Hlasovať!',
      vote_entered: 'Vaše hlasovanie bolo zaznamenané',
      your_ballot: 'Váš hlasovací lístok'
    },
    it: {
      add: 'Inserisci',
      already_voted: 'Hai già votato in questa elezione',
      ballot_error: 'Errore di voto',
      choice_list: 'Lista di scelte',
      confirm: 'Conferma',
      confirm_empty: "Seleziona la casella 'Voglio inviare una scheda vuota' per confermare che la tua scheda è intenzionalmente vuota.",
      go_back: 'Torna indietro',
      may_select:
        'Puoi selezionare fino a %{smart_count} scelta per %{title}||||' +
        'Puoi selezionare fino a %{smart_count} scelta per %{title}',
      must_rank_all: 'Devi ordinare tutte le scelte per %{title}',
      no_candidate_chosen: 'Nessuna scelta effettuata',
      please_confirm: 'Per favore conferma il tuo voto',
      remove: 'Rimuovi',
      required_to_select:
'È necessario selezionare %{smart_count} scelta per %{title}||||' +
'È necessario selezionare %{smart_count} scelte per %{title}',
      sending_vote: 'Invio del voto ...',
      vote: 'Vota!',
      vote_entered: 'Il tuo voto è stato registrato',
      your_ballot: 'Il tuo voto'
    },
    fi: {
      add: 'Lisää',
      already_voted: 'Olet jo äänestänyt tässä kyselyssä',
      ballot_error: 'Äänestysvirhe',
      choice_list: 'Valintaluettelo',
      confirm: 'Vahvista',
      confirm_empty: "Valitse 'Haluan lähettää tyhjän äänestyslipun' -ruutu vahvistaaksesi, että äänestyslippusi on tarkoituksella tyhjä.",
      go_back: 'Palaa',
      may_select:
        'Voit valita enintään %{smart_count} vaihtoehdon äänestyksessä ' +
        '%{title}||||' +
        'Voit valita enintään %{smart_count} vaihtoehtoa äänestyksessä ' +
        '%{title}',
      must_rank_all: 'Sinun on arvotettava kaikki vaihtoehdot äänestyksessä ' +
      '%{title}',
      no_candidate_chosen: 'Ei valintoja',
      please_confirm: 'Vahvista valintasi',
      remove: 'Poista',
      required_to_select:
'Sinun on valittava tarkalleen %{smart_count} vaihtoehto äänestyksessä ' +
'%{title}||||' +
'Sinun on valittava tarkalleen %{smart_count} vaihtoehtoa äänestyksessä ' +
'%{title}',
      sending_vote: 'Lähetetään ääntä...',
      vote: 'Äänestä!',
      vote_entered: 'Äänesi on annettu',
      your_ballot: 'Sinun valintasi'
    }
  };

  function get_vote_preview() {
    var html = '';
    for (var i = 0; i < data.contests.length; i++) {
      var $ballot = $('#ballot-' + i);
      html += '<p><b>' + data.contests[i].title + '</b></p>';
      var unordered = data.contests[i].ballot_type === 'choose one';
      var candidates = $ballot.find('ol li');
      if (unordered) { html += '<ul>' } else { html += '<ol>' }
      for (var j = 0; j < candidates.length; j++) {
        html += '<li>' + $(candidates[j]).html() + '</li>';
      }
      if (candidates.length == 0) {
        html += '<li>' + pg.t('no_candidate_chosen') + '</li>';
      }
      if (unordered) { html += '</ul>' } else { html += '</ol>' }
    }
    return html;
  }

  function validate_vote() {
    var valid = true;
    var txt = '';
    var allows_empty_ballot = true;
    var empty_ballot = true;
    for (var i = 0; i < data.contests.length; i++) {
      var $ballot = $('#ballot-' + i);
      var method = data.contests[i]['method'];
      var require_full = data.contests[i]['require_full'];
      var ballot_type = data.contests[i]['ballot_type'];
      var n_cand = data.contests[i]['candidates'].length;
      var n_seats = data.contests[i]['n_seats'];
      var n_selected = $ballot.find('ol li').length;
      var title = data.contests[i]['title'];

      if (require_full === 'yes') {
        allows_empty_ballot = false;
      }

      if (n_selected > 0) {
        empty_ballot = false;
      }

      if (method === 'Plurality/FPTP/SNTV' ||
          method === 'Plurality at Large/Block Voting/MNTV') {

        // For plurality, the voter can select a maximum of 1 candidate.
        // For plurality at large, the maximum is the number of seats.
        var max_selections = (method === 'Plurality/FPTP/SNTV') ? 1 : n_seats;

        // For require_full, make sure the voter has checked the max number
        if (require_full === 'yes' && n_selected != max_selections) {
          txt += '<p>';
          txt += pg.t('required_to_select',
                      {smart_count: max_selections, title: title});
          txt += '.</p>';
          valid = false;
        }

        // If not require_full, then just check for too many selections
        if (require_full === 'no' && n_selected > max_selections) {
          txt += '<p>';
          txt += pg.t('may_select',
                      {smart_count: max_selections, title: title});
          txt += '.</p>';
          valid = false;
        }

      } else if (ballot_type === 'ranked enhanced' && require_full === 'yes' &&
                 n_selected != n_cand) {
        // For ranked enhanced ballot and require_full, make sure all are ranked
        txt += '<p>';
        txt += pg.t('must_rank_all', {title: title});
        txt += '.</p>';
        valid = false;
      }
    }

    const confirm_empty_checked = $('#submit_empty').is(':checked');
    if (allows_empty_ballot && empty_ballot && !confirm_empty_checked) {
      txt += '<p>' + pg.t('no_candidate_chosen') + '.</p>';
      txt += '<p>' + pg.t('confirm_empty') + '</p>';
      valid = false;
    }

    return {valid: valid, msg: txt};
  }

  function confirm_vote(event, valid, msg) {
    if (valid) {
      var title = pg.t('please_confirm');
      opavote_dlg.confirm_vote(event, get_vote_preview(), title,
                               pg.t('confirm'), pg.t('go_back'));
    } else {
      opavote_dlg.msg_md(msg, pg.t('ballot_error'));
      return false;
    }
  }

  function validate_and_confirm_vote(event) {
    var x = validate_vote();
    return confirm_vote(event, x.valid, x.msg);
  }

  function check_candidate(e) {
    // No error checking is done here.  Just add or remove check marks.
    var $ballot = $(e.delegateTarget);
    var $candidate = $(e.target);
    var candidate_id = $candidate.data('token');
    var is_checked = $candidate.hasClass('checked');
    if (is_checked) {
      // Remove the candidate from the ol
      $ballot.find('ol #' + candidate_id).remove();
      $candidate.toggleClass('empty checked');
    } else {
      // Remove a candidate if too many for Plurality methods
      var i = parseInt($ballot.attr('id').replace(/[^0-9]/g, ''), 10);
      var method = data.contests[i]['method'];
      if (method === 'Plurality/FPTP/SNTV' ||
          method === 'Plurality at Large/Block Voting/MNTV') {
        var n_seats = data.contests[i]['n_seats'];
        var max_selections = (method === 'Plurality/FPTP/SNTV') ? 1 : n_seats;
        var n_selected = $ballot.find('ol li').length;
        if (n_selected == max_selections) {
          remove_id = $ballot.find('ol li').first().attr('id');
          $ballot.find('ol li').first().remove();
          $remove_cand = $ballot.find('ul li[data-token="' + remove_id + '"]');
          $remove_cand.toggleClass('empty checked');
        }
      }
      // Add candidate to the ol
      var $ranking = $('<li>' + $candidate.html() + '</li>');
      $ranking.attr('id', candidate_id);
      $ballot.find('ol').append($ranking);
      $candidate.toggleClass('empty checked');
    }
    toggle_empty_ballot_confirmation()
  }

  function toggle_candidate(e) {
    var $button = $(e.target);
    var $ballot = $(e.delegateTarget);
    var name = $button.next().html();
    var code = $button.parent().attr('class');
    var command = $button.hasClass('add') ? 'add' : 'remove';
    if (command === 'add') {
      var $ranking = $('<li>' + name + '</li>');
      $ranking.attr('id', code);
      $ballot.find('ol').append($ranking);
      $button.html(pg.t('remove'));
    } else {
      $ballot.find('#' + code).remove();
      $button.html(pg.t('add'));
    }
    $button.toggleClass('add remove');
    toggle_empty_ballot_confirmation()
  }

  function set_ballot_dimensions($ballot, i) {
    var ballot_type = data.contests[i]['ballot_type'];
    // For the choose one, the <ol> is not visible so it doesn't matter.
    if (ballot_type === 'choose one') {
      return;
    }
    // For ranked enhanced, add all candidates so we can measure the width and
    // height and then fix it.  For ranked simple, candidates already on ballot.
    if (ballot_type === 'ranked enhanced') {
      $ballot.find('ul li button').each(function() { this.click(); });
    }
    // Fix the ballot width.  Note that we need this for both ranked simple and
    // ranked enhanced ballots.  For ranked simple, moving the longest ballot
    // item temporarily changes ballot size so fix the width to prevent this.
    var $box = $ballot.find('.ballot-box');
    var width = Math.max(150, parseFloat($box.css('width')));
    $box.css('width', width + 'px');
    // Fix the ballot box height
    var height = $box.css('height');
    $box.css('height', height);
    // Add line numbers.  We can't use the <ol> line numbers because they move
    // with the candidate and we want them fixed.
    var n_cand = $ballot.find('ol li').length;
    for (var j = 0; j < n_cand; j++) {
      var number = $('<p>' + (j + 1) + '.</p>').css('position', 'absolute');
      var list_item = $box.find('ol li')[j];
      var top = parseInt($(list_item).position().top, 10) + 7;
      number.css('top', top + 'px');
      number.css('left', 6); // left padding on <ol> is 30
      $box.append(number);
    }
    // For ranked enhanced, fix the width of the candidate list, because the
    // button widths change when candidates are added to the ballot.  We want
    // the wider of the Add/Remove buttons.
    if (ballot_type === 'ranked enhanced') {
      var $candidate_list = $ballot.find('.candidate-list');
      var width1 = parseFloat($candidate_list.css('width'));
      // Reset the ranked enhanced ballot
      $candidate_list.find('li button').each(function() { this.click(); });
      var width2 = parseFloat($candidate_list.css('width'));
      width = Math.max(width1, width2);
      $candidate_list.css('width', width + 'px');
    }
  }

  function vote_submission() {
    // Serialize the data for submission
    for (var i = 0; i < data.contests.length; i++) {
      var $ballot = $('#ballot-' + i);
      var $ol = $ballot.find('ol');
      $('#order-' + i).val($ol.sortable('serialize'));
    }
  }

  function get_order(n, shuffle) {
    // Return a shuffled array of [0..n-1]
    var tmp, current, order = [];
    for (var i = 0; i < n; i++) { order.push(i) }
    if (shuffle == 'no') { return order }
    if (n) while (--n) {
      current = Math.floor(Math.random() * (n + 1));
      tmp = order[current];
      order[current] = order[n];
      order[n] = tmp;
    }
    return order;
  }

  function choose_one_ballot(i) {
    var contest = data.contests[i];
    var html;
    html = '<div class="notranslate ballot-box choose-one">\n' +
           '<p>' + pg.t('your_ballot') + ':</p>\n' +
           '<ul>\n';
    var order = get_order(contest.candidates.length, contest.shuffle_cand);
    for (var j = 0; j < contest.candidates.length; j++) {
      var id = 'r' + i + '_' + order[j];
      var name = contest.candidates[order[j]];
      // Element data used here and id used in <ol> when checked.
      html += '<li class="empty" data-token="' + id + '">' + name + '</li>\n';
    }
    html += '</ul>\n<ol></ol>\n</div>\n';
    return html;
  }

  function ranked_simple_ballot(i) {
    var contest = data.contests[i];
    var html;
    html = '<div class="notranslate ballot-box">\n' +
           '<p>' + pg.t('your_ballot') + ':</p>\n' +
           '<ol>\n';
    var order = get_order(contest.candidates.length, contest.shuffle_cand);
    for (var j = 0; j < contest.candidates.length; j++) {
      var id = 'r' + i + '_' + order[j];
      var name = contest.candidates[order[j]];
      html += '<li id="' + id + '">' + name + '</li>\n';
    }
    html += '</ol>\n</div>\n';
    return html;
  }

  function ranked_enhanced_ballot(i) {
    var contest = data.contests[i];
    var html;
    html = '<div class="notranslate candidate-list">\n' +
           '<p>' + pg.t('choice_list') + ':</p>\n' +
           '<ul>\n';
    var order = get_order(contest.candidates.length, contest.shuffle_cand);
    for (var j = 0; j < contest.candidates.length; j++) {
      var id = 'r' + i + '_' + order[j];
      var name = contest.candidates[order[j]];
      // Class used here and id used in <ol> when added to ballot.
      html += '<li class="' + id + '">';
      html += '<button type="button" class="btn btn-default btn-sm add">' +
              pg.t('add') + '</button><span>' + name + '</span>';
      html += '</li>\n';
    }
    html += '</ul>\n' +
            '</div>\n' +
            '<div class="notranslate ballot-box">\n' +
            '<p>' + pg.t('your_ballot') + ':</p>\n' +
            '<ol></ol>\n' +
            '</div>\n';
    return html;
  }

  function add_ballots() {
    for (var i = 0; i < data.contests.length; i++) {
      var $ballot = $('#ballot-' + i);
      $ballot.addClass('ballot-wrapper');
      var ballot_type = data.contests[i]['ballot_type'];
      // Add events to ballots
      if (ballot_type === 'choose one') {
        $ballot.html(choose_one_ballot(i));
        $ballot.on('click', 'ul li', check_candidate);
      } else if (ballot_type === 'ranked simple') {
        $ballot.html(ranked_simple_ballot(i));
      } else if (ballot_type === 'ranked enhanced') {
        $ballot.html(ranked_enhanced_ballot(i));
        $ballot.on('click', 'ul li button', toggle_candidate);
      }
      // Make sortable
      var $box = $ballot.find('.ballot-box');
      $ballot.find('ol').sortable(
        {axis: 'y', containment: $box, scroll: false});
      $ballot.find('ol').disableSelection();
      // Fix ballot dimensions
      set_ballot_dimensions($ballot, i);
    }
  }

  my.init = function(election_data) {
    if (election_data === null) return;
    var locale = $('#data-locale').data('locale');
    pg = new Polyglot({phrases: translations[locale]});
    data = election_data;
    add_ballots();
    // Add handlers to page
    $('#enter-vote-btn').prop('disabled', false);
    $('#enter-vote-btn').click(validate_and_confirm_vote);
    $('#ballot-form').submit(vote_submission);
  };

  function widget_results_callback(results) {
    $('#opavote-voting').show();
    if (results.error) {
      $('#opavote-voting').html('<p><b>' + results.msg + '</b></p>');
    } else {
      // Tell voter if they just voted or previously voted
      if (get_cookie()) {
        var msg = pg.t('already_voted') + '.';
      } else {
        var msg = pg.t('vote_entered') + '.';
      }
      $('#opavote-voting').html('<p><b>' + msg + '</b></p>');
      $('#opavote-voted').show();
      $('#opavote-results').html(results.html);
      if (data.poll_registration == 'cookie') { set_cookie() }
    }
  }

  function widget_vote_submission() {
    // For now, assume one contest and don't submit empty votes.
    if ($('#ballot-0 ol li').length == 0) { return }
    // Prevent double click and tell voter that vote is being processed.
    $('#vote-button').html(pg.t('sending_vote'));
    // Regular vote processing
    var url = host + '/api/v1/widget-vote/' + data.eid + '?callback=?';
    var orders = {};
    for (var i = 0; i < data.contests.length; i++) {
      var $ballot = $('#ballot-' + i);
      var $ol = $ballot.find('ol');
      orders['order-' + i] = $ol.sortable('serialize');
    }
    $.getJSON(url, orders, widget_results_callback).fail(widget_error);
  }

  function page_check() {
    // Check basic requirements of page to aid in debugging.
    // If outermost div is missing then don't show a message.
    if (!$('#opavote-widget').length) {
      return false;
    }
    // Show error messages for other issues
    var ok = false;
    var msg;
    var link = $('#opavote-logo a').attr('href');
    var link_text = $('#opavote-logo a').text();
    if (!$('#opavote-widget #opavote-voting').length ||
        !$('#opavote-voting #ballot-0').length ||
        !$('#opavote-voting #vote-button').length ||
        !$('#opavote-widget #opavote-voted').length ||
        !$('#opavote-voted #opavote-results').length ||
        !$('#opavote-widget #opavote-logo').length) {
      msg = 'You have copied the OpaVote widget code incorrectly. ' +
            'Please check our documentation.';
    } else if (link != 'https://opavote.com' || link_text != 'OpaVote') {
      msg = 'To use the OpaVote poll widget, you must keep the ' +
            'OpaVote attribution!';
    } else {
      ok = true;
    }
    if (!ok) { $('#opavote-widget').html('<p><b>' + msg + '</b></p>') }
    return ok;
  }

  function data_check() {
    // Make sure that we have a poll past the EDITING stage.
    var ok = false;
    var msg;
    if (data.error) {
      msg = data.msg;
    } else if (data.mode != 'poll') {
      msg = 'OpaVote widget only works for polls!';
    } else if (data.contests.length > 1) {
      msg = 'OpaVote poll widget only works with one contest.';
    } else if (data.contests[0].require_full == 'yes') {
      msg = 'OpaVote widget only works with "require full vote" set to no.';
    } else if (data.status == 'EDITING') {
      msg = 'Voting has not opened yet.';
    } else {
      ok = true;
    }
    if (!ok) { $('#opavote-widget').html('<p><b>' + msg + '</b></p>') }
    return ok;
  }

  function set_cookie() {
    var exp = new Date();
    exp.setDate(exp.getDate() + 30);
    document.cookie = data.eid + '=true; expires=' + exp.toUTCString();
  }

  function get_cookie() {
    return document.cookie.indexOf(data.eid + '=true') >= 0;
  }

  function widget_start(election_data) {
    data = election_data;
    if (!page_check()) { return }
    if (!data_check()) { return }
    if (data.status == 'VOTING' && !get_cookie()) {
      // Show ballot
      $('#opavote-voting').show();
      add_ballots();
      $('#vote-button').html('<button type="button" ' +
        'class="btn btn-lg btn-success">' + pg.t('vote') + '</button>');
      $('#vote-button button').click(widget_vote_submission);
    } else {
      // Get results to show user
      var url = host + '/api/v1/widget-results/' + data.eid + '?callback=?';
      $.getJSON(url, widget_results_callback).fail(widget_error);
    }
  }

  function widget_error() { alert('Error retrieving poll data.') }

  function toggle_empty_ballot_confirmation() {
    const $submit_empty_ballot_holder = $('#submit_empty_ballot_holder');
    if($('.ballot-wrapper li.checked,.ballot-wrapper button.remove').length > 0) {
      $submit_empty_ballot_holder.hide();
    } else {
      $submit_empty_ballot_holder.show();
    }
  }

  my.widget = function(eid, h) {
    var locale = navigator.languages && navigator.languages[0] || // Chrome/FF
                 navigator.language ||   // Other browsers
                 navigator.userLanguage; // IE <= 10
    locale = locale.split('-', 1)[0];
    locale = ['en', 'fr'].indexOf(locale) == -1 ? 'en' : locale;
    pg = new Polyglot({phrases: translations[locale]});
    host = h;
    if (typeof host === 'undefined') host = 'https://opavote.com';
    var url = host + '/api/v1/items/' + eid + '?callback=?';
    $.getJSON(url, widget_start).fail(widget_error);
  };

  // For unit testing code
  my._get_order = get_order;
  my._toggle_candidate = toggle_candidate;
  my._check_candidate = check_candidate;
  my._validate_vote = validate_vote;
  my._get_vote_preview = get_vote_preview;
  my._vote_submission = vote_submission;

  return my;

}(jQuery));
